// @flow

import { getRedirectUrlAfterPayment } from './get-redirect-url-after-payment';
import type { IncomingPayment } from './types';
import { shouldCheckForPaymentConfirmation } from '@tectonics/prs/merchant/config';
import { getMerchant } from './get-merchant';

export function redirectIfCheckForConfirmationIsEnabled(incomingPayment: IncomingPayment) {

  const redirectUrl = getRedirectUrlAfterPayment(incomingPayment);
  const merchant = getMerchant(incomingPayment);

  if (shouldCheckForPaymentConfirmation(merchant) && redirectUrl) {
    setTimeout(() => window.location = redirectUrl, 500);
  }
}
